export default "__VITE_ASSET__HY66CpBG__"